(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vPlatform-resource-29ee768144ce68cbddff76c0a39b52c9", [], factory);
	else if(typeof exports === 'object')
		exports["vPlatform-resource-29ee768144ce68cbddff76c0a39b52c9"] = factory();
	else
		root["vPlatform-resource-29ee768144ce68cbddff76c0a39b52c9"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition